export const DEFAULT_AWS_CREDENTIALS = {
  urlLink: '...',
  username: '...',
  accessKeyId: '...',
  secretAccessKey: '...',
  defaultConsolePassword: '...',
};

export const DEFAULT_STATUS_MAPPINGS = {
  tagType: 'error',
  circleIconColor: 'error',
  iconTagText: 'Not Ready',
  panelText: 'You do not have access to any environment',
  showRoomList: false,
  showClose: true,
  showGenerateEnvironment: false,
  showResetEnvironment: false,
};
